import { defineMessage } from 'services/localization';

export const messages = {
    paidPreviously: defineMessage('you_have_paid_this_cont__in_the_payment_details'),
    neverPaid: defineMessage('you_are_paying_this_contact_for_the_first_time'),
    paymentDetailsChanged: defineMessage('you_have_paid_this_cont_nt_details_have_changed'),
};
